export const PAGE_SIZE = 25;

// One dialog serves every write. The three modes differ only in how much is
// pre-filled and locked, so keeping them in one component keeps a single
// validation path for what is a hard lock on dispensing.
export const DIALOG_MODE = {
  // Launched from the toolbar: pick the partner too. This is the only route to a
  // partner that has no preferences yet, since such partners are not listed.
  ADD_ANY: 'ADD_ANY',
  // Launched from inside an expanded partner: partner is fixed, pick the drug.
  ADD_FOR_PARTNER: 'ADD_FOR_PARTNER',
  // Launched from a preference row: partner and drug are both fixed.
  CHANGE: 'CHANGE',
};

// The counts query orders on partner name only and takes a direction, so Partner
// is the single sortable column.
export const COLUMNS = [
  { id: 'partnerName', label: 'Partner', sortable: true },
  { id: 'partnerStatus', label: 'Status', sortable: false, align: 'center', width: 160 },
  {
    id: 'preferenceCount',
    label: 'Preferences',
    sortable: false,
    align: 'center',
    width: 140,
  },
  // Trails the count rather than leading the row: the count is what the eye is
  // looking for, and the chevron sits next to it as the thing to act on.
  { id: 'expand', label: '', sortable: false, align: 'center', width: 56 },
];

// The counts query carries no partner status, so it is joined client-side from
// the partner list already in the store. Suspended wins over disabled: it is the
// more specific state and the one that needs acting on.
export const PARTNER_STATUS = {
  ACTIVE: 'ACTIVE',
  SUSPENDED: 'SUSPENDED',
  INACTIVE: 'INACTIVE',
};

export const PARTNER_STATUS_CHIP = {
  [PARTNER_STATUS.ACTIVE]: { label: 'Active', color: 'success' },
  [PARTNER_STATUS.SUSPENDED]: { label: 'Suspended', color: 'warning' },
  [PARTNER_STATUS.INACTIVE]: { label: 'Inactive', color: 'default' },
};

export const COLUMN_COUNT = COLUMNS.length;

// The child list arrives in one unpaginated fetch, so sorting and filtering it is
// pure client-side work on data already in memory.
export const CHILD_SORT_KEY = {
  CATALOG_NAME: 'catalogName',
  MANUFACTURER: 'manufacturer',
  UPDATED: 'modifiedTimestamp',
};

export const CHILD_DEFAULT_SORT = { key: CHILD_SORT_KEY.CATALOG_NAME, order: 'asc' };

// Below this the filter box is not rendered at all: a control above three rows is
// chrome, not help, and the common case is a handful of preferences.
export const CHILD_FILTER_THRESHOLD = 10;
